import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { Edit } from '@mui/icons-material'
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  TextField,
  TextareaAutosize,
} from '@mui/material'
import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'
import FormField from 'components/FormField'
import MDInput from 'components/MDInput'
import { useAgencyInfo } from 'context/agency'

const CreateModal = ({ products, handleRefresh }) => {
  const [agency] = useAgencyInfo()

  const uploadImage = useUploadImage()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const [allApps, setAllApps] = useState([])
  const [selectedApps, setSelectedApps] = useState([])
  const [selectedAppTypes, setSelectedAppTypes] = useState([])
  const AppService = useAppServices()
  const [user] = useUserInfo()
  var axios = require('axios')

  useEffect(() => {
    let isMounted = true;

    const getApps = async () => {
      const { response } = await AppService.app.get({
        query: `app_type.value=both`,
      });
      if (isMounted && response) {
        setAllApps(response.data);
      }
    };

    getApps();

    return () => {
      isMounted = false;
    };
  }, []);

  const handlemodal = () => {
    setOpenAddProduct(true)
  }

  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)

    const handleSubmit = async (e) => {
      e.preventDefault()

      const data = {
        name: e.target.name.value,
        apps: selectedApps,
        app_type: selectedAppTypes,
        created_by: 'superadmin',
        agency_id: agency._id,
      }
      const payload = {
        data: data,
      }

      const { response } = await AppService.ActionsCategories.create({
        payload: payload,
      })

      if (response) {
        setProcessing(false)
        onClose()
        handleRefresh()
      }
    }

    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      maxHeight: '80vh',
      overflow: 'auto',
      bgcolor: 'background.paper',
      border: '2px  #000',
      boxShadow: 24,
      p: 4,
    }

    const handleChangeApps = (event) => {
      const { value } = event.target;
      setSelectedApps(typeof value === 'string' ? value.split(',') : value);
    }

    const handleChangeAppTypes = (event) => {
      const { value } = event.target;
      setSelectedAppTypes(typeof value === 'string' ? value.split(',') : value);
    }

    const appsTypes = [
      { label: 'Payment Provider', value: 'payment_provider' },
      { label: 'Conversation Provider', value: 'conversation_provider' },
      { label: 'Actions', value: 'actions' },
      { label: 'Triggers', value: 'triggers' },
      { label: 'Custom JS', value: 'custom_js' },
      { label: 'Custom Page', value: 'custom_page' },
      { label: 'Widget', value: 'widget' },
      { label: 'Snapshot', value: 'snapshot' }
    ];

    return (
      <MDModal open={open} onClose={onClose}>
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              Apps Collection
            </MDTypography>

            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Select Apps
              </MDTypography>

              <Select
                placeholder="Select Apps"
                name="apps"
                fullWidth
                multiple
                value={selectedApps}
                onChange={handleChangeApps}
                input={<OutlinedInput id="select-multiple-chip" label="Select Apps" />}
              >
                {allApps?.map((data) => (
                  <MenuItem key={data?.app_id} value={data?.app_id}>
                    {data?.name}
                  </MenuItem>
                ))}
              </Select>
            </MDBox>

            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                App Type
              </MDTypography>
              <Select
                fullWidth
                multiple
                name="app_type"
                value={selectedAppTypes}
                onChange={handleChangeAppTypes}
                input={<OutlinedInput id="select-multiple-chip" label="App Type" />}
              >
                {appsTypes.map((type) => (
                  <MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>
                ))}
              </Select>
            </MDBox>

            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Name
              </MDTypography>
              <MDInput label="Name" placeholder="Name" name="name" fullWidth />
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton variant="gradient" color="primary" type="button" sx={{ mt: 4, mb: 1 }} onClick={onClose}>
                Close
              </MDButton>
              <MDButton variant="gradient" color="info" type="submit" sx={{ mt: 4, mb: 1, ml: 1 }} loading={processing} disabled={processing}>
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handlemodal}>
        Create
      </MDButton>
      <AddProduct open={openAddProduct} onClose={() => setOpenAddProduct(false)} />
    </>
  )
}

export default CreateModal